import React from "react";

const Section5 = ({ url }) => {

  const pricingItems = [
    {
      icon: <img src={`${url}images/offshoreDevelopment/sec5/1.png`} alt="Pricing" />,
      title: "How Pricing Works",
      desc: "ExD Digital's engagement pricing is straightforward: you pay an hourly rate per developer based on their seniority level. Junior developers, mid-level engineers, and senior developers are each priced differently, reflecting the depth of experience and level of autonomy each brings to your project. Exact rates for your required stack and seniority mix are confirmed during the discovery call, where we match you with the right team profile for your budget and scope.",
    },
    {
      icon: <img src={`${url}images/offshoreDevelopment/sec5/2.png`} alt="Partnership" />,
      title: "No Minimum Commitment",
      desc: "There is no minimum team size and no minimum contract duration at ExD Digital. You can begin with a single developer for a single month. This is intentional. We believe the fastest way to build a long-term partnership is to let you experience the quality of our team at the lowest possible risk. Most clients who start with one developer for one month extend the engagement within 60 days.",
    },
    {
      icon: <img src={`${url}images/offshoreDevelopment/sec5/3.png`} alt="Growth" />,
      title: "Cost Advantage vs Local Hiring",
      desc: "Offshore development through ExD Digital delivers significant cost savings compared to hiring equivalent talent locally in the US, UK, or Canada, without compromising on the communication standards, timezone alignment, or technical quality your team expects. The specific cost comparison for your required seniority level and stack will be discussed transparently on your discovery call.",
    },
  ];

  return (
    <section className="home-section-5">
      <div className="container overflow-hidden">

        {/* ── HEADING ── */}
        <h2 className="s5-title" data-aos="fade-up">
          Competitive Rates. Full Transparency <br/> on the Discovery Call
        </h2>
        <p className="s5-subtitle" data-aos="fade-up" data-aos-delay="100">
          ExD Digital charges on an hourly basis per developer. Rates vary based on the seniority level of each developer and the specific technology stack required.<br/> There is no minimum team size and no minimum contract duration.
        </p>

        {/* ── 3 COLUMN PRICING INFO ── */}
        <div className="s5-grid" data-aos="fade-up" data-aos-delay="200">
          {pricingItems.map((item, idx) => (
            <div className="s5-grid-item" key={idx}>
               <div className="s5-item-icon">{item.icon}</div>
              <h3 className="s5-item-title">{item.title}</h3>
              <p className="s5-item-desc">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* ── CTA BANNER ── */}
        <div className="s5-cta-banner" data-aos="fade-up" data-aos-delay="300">
          <h3 className="s5-cta-title">Start with 1 developer for 1 month</h3>
          <p className="s5-cta-desc">
            Most offshore agencies require 3-month minimums. We don't.
          </p>
        </div>

      </div>
    </section>
  );
};

export default Section5;